<template>
  <div class="h-table">
    <div class="el-table-wrapper" ref="elTableWrapper">
      <el-table
        :data="data"
        :border="border"
        :stripe="stripe"
        :row-class-name="rowClassName"
        :highlight-current-row="highlightCurrentRow"
        :tooltip-effect="tooltipEffect"
        :default-sort="defaultSort"
        :row-key="rowKey"
        :default-expand-all="defaultExpandAll"
        :tree-props="treeProps"
        :show-summary="showSummary"
        :summary-method="summaryMethod"
        :span-method="spanMethod"
        :size="size"
        :fit="fit"
        :show-header="showHeader"
        :row-style="rowStyle"
        :height="tableHeight + 'px'"
        :cell-class-name="cellClassName"
        :cell-style="cellStyle"
        :header-row-class-name="headerRowClassName"
        :header-row-style="headerRowStyle"
        :header-cell-class-name="headerCellClassName"
        :header-cell-style="headerCellStyle"
        :empty-text="emptyText"
        :sum-text="sumText"
        :expand-row-keys="expandRowKeys"
        :select-on-indeterminate="selectOnIndeterminate"
        :indent="indent"
        :lazy="lazy"
        :load="load"
        @select="
          (selection, row) => {
            $emit('select', selection, row);
          }
        "
        @select-all="
          (selection) => {
            $emit('selectAll', selection);
          }
        "
        @selection-change="
          (selection) => {
            $emit('selectionChange', selection);
          }
        "
        @cell-mouse-enter="
          (row, column, cell, event) => {
            $emit('cellMouseEnter', row, column, cell, event);
          }
        "
        @cell-mouse-leave="
          (row, column, cell, event) => {
            $emit('cellMouseLeave', row, column, cell, event);
          }
        "
        @cell-click="
          (row, column, cell, event) => {
            $emit('cellClick', row, column, cell, event);
          }
        "
        @cell-dblclick="
          (row, column, cell, event) => {
            $emit('cellDblclick', row, column, cell, event);
          }
        "
        @row-click="
          (row, column, event) => {
            $emit('rowClick', row, column, event);
          }
        "
        @row-contextmenu="
          (row, column, event) => {
            $emit('rowContextmenu', row, column, event);
          }
        "
        @row-dblclick="
          (row, column, event) => {
            $emit('rowDblclick', row, column, event);
          }
        "
        @header-click="
          (column, event) => {
            $emit('headerClick', column, event);
          }
        "
        @header-contextmenu="
          (column, event) => {
            $emit('headerContextmenu', column, event);
          }
        "
        @sort-change="
          ({ column, prop, order }) => {
            $emit('sortChange', column, prop, order);
          }
        "
        @filter-change="
          (filters) => {
            $emit('filterChange', filters);
          }
        "
        @current-change="
          (currentRow, oldCurrentRow) => {
            $emit('currentChange', currentRow, oldCurrentRow);
          }
        "
        @header-dragend="
          (newWidth, oldWidth, column, event) => {
            $emit('headerDragend', newWidth, oldWidth, column, event);
          }
        "
        @expand-change="
          (row, expandedRows) => {
            $emit('expandChange', row, expandedRows);
          }
        "
      >
        <slot />
      </el-table>
    </div>
    <div class="el-pagination-wrapper" v-if="pagination">
      <el-pagination
        background
        @size-change="$emit('pageChange')"
        @current-change="$emit('pageChange')"
        :current-page.sync="_nowPage"
        :page-sizes="pageSizes"
        :page-size.sync="_pageSize"
        layout="total, sizes, prev, pager, next"
        :pager-count="5"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "hTable",
  props: {
    //表格数据
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    expandRowKeys: {
      type: Array,
    },
    indent: {
      type: Number,
      default() {
        return 16;
      },
    },
    sumText: {
      type: String,
      default() {
        return "合计";
      },
    },
    size: {
      type: String,
    },
    fit: {
      type: Boolean,
      default() {
        return true;
      },
    },
    tooltipEffect: {
      type: String,
      default() {
        return "";
      },
    },
    rowKey: {
      type: String,
      default() {
        return "";
      },
    },
    emptyText: {
      type: String,
      default() {
        return "暂无数据";
      },
    },
    lazy: {
      type: Boolean,
    },
    defaultExpandAll: {
      type: Boolean,
      default() {
        return false;
      },
    },
    stripe: {
      type: Boolean,
      default() {
        return false;
      },
    },
    border: {
      type: Boolean,
      default() {
        return false;
      },
    },
    selectOnIndeterminate: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showHeader: {
      type: Boolean,
      default() {
        return true;
      },
    },
    highlightCurrentRow: {
      type: Boolean,
      default() {
        return false;
      },
    },
    treeProps: {
      type: Object,
      default() {
        return { hasChildren: "hasChildren", children: "children" };
      },
    },
    defaultSort: {
      type: Object,
    },
    rowClassName: {
      type: Function,
    },
    showSummary: {
      type: Boolean,
    },
    summaryMethod: {
      type: Function,
    },
    spanMethod: {
      type: Function,
      default() {
        return () => {
          return {
            rowspan: 1,
            colspan: 1,
          };
        };
      },
    },
    rowStyle: {
      type: Function,
    },
    cellClassName: {
      type: Function,
    },
    cellStyle: {
      type: Function,
    },
    headerRowClassName: {
      type: Function,
    },
    headerRowStyle: {
      type: Function,
    },
    headerCellClassName: {
      type: Function,
    },
    headerCellStyle: {
      type: Function,
    },
    load: {
      type: Function,
    },
    //分页

    //显示分页
    pagination: {
      type: Boolean,
      default() {
        return false;
      },
    },
    nowPage: {
      type: Number,
      default() {
        return 1;
      },
    },
    pageSize: {
      type: Number,
      default() {
        return 20;
      },
    },
    total: {
      type: Number,
      default() {
        return 0;
      },
    },
    pageSizes: {
      type: Array,
      default() {
        return [20, 50, 100, 200];
      },
    },
  },
  data() {
    return {
      tableHeight: 0,
    };
  },
  computed: {
    _nowPage: {
      get() {
        return this.nowPage;
      },
      set(val) {
        this.$emit("update:nowPage", val);
      },
    },
    _pageSize: {
      get() {
        return this.pageSize;
      },
      set(val) {
        this.$emit("update:pageSize", val);
      },
    },
  },
  mounted() {
    this.setTableHeight();
  },
  methods: {
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = this.$refs.elTableWrapper.offsetHeight;
      });
    },
  },
};

// h-table 二次封装el-table
// 原功能正常使用,<h-table>标签中需要将 - 该为驼峰 例 :row-key -> :rowKey , @row-click -> @rowClick
// 自适应高度只需要给h-table style中设置高度 或在flex布局下 flex:1 既可
// 加入分页 分页操作回调为 @pageChange
</script>

<style scoped lang="scss">
.h-table {
  width: 100%;
  min-height: 400px;
  // flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.el-table-wrapper {
  height: 0;
  flex: 1;
}
.el-pagination-wrapper {
  margin-top: 5px;
  text-align: right;
  flex-shrink: 0;
}
.el-table {
  width: 100%;
  transition: all 0.2s;
}
</style>
